import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path fill="var(--svg-color-main, black)" d="m8.5 9 3.5 3 3.5-3L18 5V3H6v2z" opacity="0.4"></path>
      <path
        fill="var(--svg-color-main, black)"
        fillRule="evenodd"
        d="M9.22 10.535C6.482 8.412 5.5 6.12 5.5 4v-.5A1.5 1.5 0 0 1 7 2h10a1.5 1.5 0 0 1 1.5 1.5V4c0 2.12-.983 4.413-3.719 6.536-.925.717-.924 2.21.007 2.919 2.73 2.08 3.712 4.265 3.712 6.383v.663A1.5 1.5 0 0 1 17 22H7a1.5 1.5 0 0 1-1.5-1.5v-.663c0-2.118.982-4.302 3.712-6.383.93-.71.932-2.202.007-2.919M7.095 5c.263 1.348 1.106 2.847 3.043 4.35q.102.08.196.165l1.665.84 1.63-.808q.11-.103.231-.197c1.937-1.503 2.78-3.002 3.043-4.35z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
